/* src/app/header/header.component.css */
body {
  background-color: #f2f2f2;
  color: #000000;
}
.header_bg {
  background: url(/assets/images/ots_bg.png) no-repeat center top;
  text-align: center;
  background-size: cover;
}
.logo {
  text-align: left;
  color: #fff;
  padding: 5px 0px 0px 25px;
}
.user_main {
  float: right;
  text-align: right;
  color: white;
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  padding: 30px 30px 30px 0px;
}
.user_main p {
  float: right;
  padding-right: 10px;
}
.user_icon {
  float: right;
  padding: 8px;
  border-radius: 30px;
  font-size: 20px;
  cursor: pointer;
}
.blw_headermain {
  text-align: left;
  color: #fff;
  padding: 10px 15px 0px 15px;
}
.blw_headermain img {
  float: left;
  padding-right: 10px;
}
.blw_headermain p {
  color: #2a2a2a;
  opacity: 0.8;
}
.round_table {
  border-radius: 20px;
  width: 100%;
  overflow-x: scroll;
}
.round_table {
  border-collapse: separate;
  border-spacing: 0;
}
.round_table tr {
  border: 1px solid #d6d6d6;
  border-radius: 20px;
  -moz-border-radius: 20px;
  -o-border-radius: 20px;
  -webkit-border-radius: 10px;
}
.round_table td {
  border-bottom: 1px solid #d6d6d6;
  background-color: #ffffff;
}
.round_table tbody tr th:nth-child(1) {
  padding-left: 20px;
}
.round_table tbody tr td:nth-child(1) {
  padding-left: 20px;
}
.round_table tbody tr td:nth-child(8) {
  padding-right: 20px;
  width: 100px;
}
.internal_main {
  padding: 0px;
}
.checkbox td {
  width: 20px;
}
.order_buttonicon {
  border-radius: 300px;
  background: #009f16 url(/assets/chasepay_icon.png) no-repeat left center !important;
  text-transform: capitalize;
  box-shadow: none;
  padding: 0px 18px 0px 37px;
  float: right;
}
.tab-content > .active {
  display: block;
}
.userbtn_main {
  margin-top: -60px;
  position: absolute;
  right: 0px;
}
.add_internaluserbtn {
  background-color: #4eb700 !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.add_internaluserbtn span {
  font-size: 16px;
}
.userlog_btn {
  background-color: #00adcc !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.transaction_btn {
  background-color: #028ba3 !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.transaction_btn img {
  float: none;
  padding: 0px;
}
.external_userlog_btn {
  background-color: #00adcc !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.external_add_internaluserbtn {
  background-color: #4eb700 !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.bulk_upload {
  background-color: #009f16 !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.external_userlog_btn img {
  float: none;
  padding: 0px;
}
.userlog_btn img {
  float: none;
  padding: 0px;
}
.round_table tbody .last_row td:last-child {
}
.round_table tbody .last_row td:first-child {
}
.round_table tbody tr th {
  border-bottom: 1px solid #d6d6d6;
}
#exTab1 .tab-content {
  color: #000000;
  padding: 0px;
  border-radius: 10px;
}
#exTab1 .nav-pills > li > a {
  border-radius: 0;
}
td,
th {
  white-space: nowrap;
  padding: 10px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}
.nav_main {
  float: left;
  background-color: #ffffff;
  border-radius: 30px;
  border: 1px solid #cccccc;
  margin-bottom: 15px;
}
.nav-pills > li > a {
  border-radius: 30px !important;
  color: #000000;
  padding: 10px 36px;
}
.nav-pills > li > a:hover {
  background-color: #ffffff !important;
}
.nav-pills > li.active > a {
  color: #fff;
  background-color: #003992 !important;
}
.edit_icon {
  float: right;
  background-color: #009f16;
  color: #ffffff;
  padding: 10px;
  border-radius: 30px;
  font-weight: bold;
}
.form-group {
  padding: 0px !important;
  margin: 0px !important;
}
.input-field label {
  font-size: 11px;
  padding-left: 5px;
  color: #8bd0f3 !important;
  font-weight: normal;
}
.input-field input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #fff;
  padding-left: 5px;
  height: 36px;
  background: transparent;
}
.submit {
  padding: 10px;
  float: right;
}
.submit_btn {
  background-color: #009f16 !important;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
input:not([type]),
input[type=text],
input[type=password],
input[type=email],
input[type=url],
input[type=time],
input[type=date],
input[type=datetime],
input[type=datetime-local],
input[type=tel],
input[type=number],
input[type=search],
textarea.materialize-textarea {
  border: 1px solid #dedede;
  height: 34px;
  width: 100%;
  font-size: 1rem;
  margin: 0px;
  padding: 0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px;
}
input:focus {
  outline: none !important;
  border-color: #cccccc;
  box-shadow: none !important;
}
[type=checkbox]:not(:checked),
[type=checkbox]:checked {
  position: absolute;
  left: 0px;
  opacity: 1;
}
.checkbox input[type=checkbox],
.checkbox-inline input[type=checkbox],
.radio input[type=radio],
.radio-inline input[type=radio] {
  margin-left: 0px;
  font-size: 20px;
}
.dropdown-menu {
  right: 15px;
  left: auto;
  border-radius: 0px;
  padding: 0px;
  border: 1px solid #e4e4e4;
}
.dropdown-menu > li > a {
  display: block;
  padding: 15px 100px 15px 10px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
}
.dropdown-menu > li > a:hover {
  background-color: #008ad0;
  color: #ffffff;
}
.drop_downicon {
  color: #ffffff;
  position: absolute;
  right: 13px;
  top: -24px;
  font-size: 30px;
}
.nameAlone {
  margin-top: 10px;
}
@media (min-width: 300px) and (max-width: 600px) {
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #505050;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #b30000;
  }
  .logo {
    text-align: left;
    color: #fff;
    padding: 15px 14px 0px 25px;
  }
  .user_main {
    float: right;
    text-align: right;
    color: white;
    border-left: solid 1px rgba(0, 0, 0, 0.2);
    padding: 15px 28px 7px 0px;
    margin-left: 0px;
  }
  .blw_headermain img {
    float: left;
    padding-bottom: 25px;
    padding-right: 10px;
  }
  .nav_main {
    float: left;
    background-color: #ffffff;
    border-radius: 30px;
    border: 1px solid #cccccc;
    margin-bottom: 100px;
  }
  .userbtn_main {
    margin-top: -100px;
    position: absolute;
    left: 0px;
  }
  .add_internaluserbtn {
    margin-top: 10px;
  }
  .userbtn_main img {
    float: right;
    padding: 4px 0px 0px 4px;
  }
  .external_userlog_btn {
    background-color: #00adcc !important;
    padding: 0px 10px;
    border-radius: 20px;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
  }
  .external_add_internaluserbtn {
    background-color: #4eb700 !important;
    padding: 0px 10px;
    border-radius: 20px;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
    margin-top: 10px;
  }
  .bulk_upload {
    background-color: #009f16 !important;
    padding: 0px 10px;
    border-radius: 20px;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
    margin-top: 10px;
  }
  .submit {
    padding: 10px;
    float: left;
  }
  .external_userlog_btn img {
    float: none;
    padding: 0px !important;
  }
}
@media (min-width: 600px) and (max-width: 900px) {
  .userbtn_main {
    margin-top: -60px;
    position: absolute;
    left: 0px;
  }
  .nav_main {
    margin-bottom: 60px;
  }
  .external_add_internaluserbtn {
    margin-top: 0px;
  }
  .bulk_upload {
    margin-top: 0px;
  }
  .add_internaluserbtn {
    margin-top: 0px;
  }
}
.unauthorizedUser {
  color: red;
  text-align: center;
}
/*# sourceMappingURL=header.component.css.map */
